import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const getCompanies = async ({ commit }) => {
  commit('setCompanyIsLoading', true);
  let url = `/companies/selectable`;

  await connection.get(url)
    .then(res => {
      const companies = res.data.data;
      commit('setCompaniesSelectable', companies);
      commit('setCompanyIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCompanyIsLoading', false);
    });
}

export const loadCompanies = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setCompanyIsLoading', true);
    let url = `/companies`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}`;
    }

    await connection.get(url)
      .then(res => {
        const companies = res.data.data;
        commit('setCompanies', companies);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setCompaniesPaginated', res.data);
        commit('setCompanyIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setCompanyIsLoading', false);
      });
}

export const companyById = async ({ commit }, id) => {
  commit('setCompanyIsLoading', true);
  await connection.get(`/companies/${id}`)
    .then(res => {
      commit('setCompanyDetail', res.data.data);
      commit('setCompanyIsLoading', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCompanyIsLoading', false);
    });
}

export const storeCompany = async ({ commit }, company) => {
  commit('setCompanyIsCreating', true);
  await connection.post(`/companies/create`, company)
    .then(res => {
      commit('saveNewCompanies', res.data.data);
      commit('setCompanyIsCreating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCompanyIsCreating', false);
    });
}

export const updateCompany = async ({ commit }, company ) => {
  commit('setCompanyIsUpdating', true);
  await connection.put(`/companies/${company.id}/update`, company)
    .then(res => {
      commit('saveUpdatedCompany', res.data.data);
      commit('setCompanyIsUpdating', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCompanyIsUpdating', false);
    });
}

export const deleteCompany = async ({ commit }, company) => {
  commit('setCompanyIsDeleting', true);
  await connection.delete(`/companies/${company.id}/delete`)
    .then(res => {
      console.log(res);
      commit('setDeleteCompany', res.data.data);
      commit('setCompanyIsDeleting', false);
    }).catch(err => {
      console.log('error', err);
      commit('setCompanyIsDeleting', false);
    });
}
